import { Component, inject } from '@angular/core';
import { Card } from 'primeng/card';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { WithdrawalHealthCheckItem, WithdrawalHealthRiskEnum } from '../../models/withdrawal-health-check';
import { Tag } from 'primeng/tag';
import { Avatar } from 'primeng/avatar';
import { SelectButton } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { DashboardService } from '../../services/dashboard.service';
import { ToastService } from '../../services/toast.service';
import { DialogService } from 'primeng/dynamicdialog';
import { AgentPerformanceDialog } from '../agent-performance-dialog/agent-performance-dialog';
import dayjs from 'dayjs';

@Component({
  selector: 'app-insights-dashboard',
  imports: [Card, TableModule, Tag, Avatar, SelectButton, FormsModule, DecimalPipe],
  templateUrl: './insights-dashboard.html',
  styleUrl: './insights-dashboard.scss',
})
export class InsightsDashboard {
  private dashboardService = inject(DashboardService);
  private toastService = inject(ToastService);
  private dialogService = inject(DialogService);

  protected readonly RiskEnum = WithdrawalHealthRiskEnum;

  loading = false;

  dateRangeOptions = [
    { label: 'All Time', value: null, icon: 'pi pi-calendar' },
    { label: 'Last 30 Days', value: 30, icon: 'pi pi-calendar' },
    { label: 'Last 60 Days', value: 60, icon: 'pi pi-calendar' },
    { label: 'Last 90 Days', value: 90, icon: 'pi pi-calendar' },
  ];
  dateRangeFilter = this.dateRangeOptions[0].value;

  first = 0;
  pageSize = 50;
  sortField = 'risk';
  sortOrder = -1;

  totalResults = 0;
  data: WithdrawalHealthCheckItem[] = [];

  onLazyLoad(event: TableLazyLoadEvent) {
    this.first = event.first || 0;
    this.pageSize = event.rows || 50;
    this.sortField = (event.sortField as string) || this.sortField;
    this.sortOrder = event.sortOrder || 1;

    const page = this.first / this.pageSize;

    this.getWithdrawalHealthCheckData(page);
  }

  getWithdrawalHealthCheckData(page: number) {
    this.loading = true;

    const sortDirection = this.sortOrder === 1 ? 'asc' : 'desc';

    let startDate = null;
    let endDate = null;

    if (this.dateRangeFilter) {
      startDate = dayjs().subtract(this.dateRangeFilter, 'days').startOf('day').format('YYYY-MM-DD');
      endDate = dayjs().endOf('day').format('YYYY-MM-DD');
    }

    this.dashboardService
      .getWithdrawalHealthCheckData(page, this.pageSize, this.sortField, sortDirection, startDate, endDate)
      .then((response) => {
        if (response) {
          this.data = response.items;
          this.totalResults = response.totalResults;
          this.loading = false;
        }
      })
      .catch((error) => {
        this.toastService.showError('Error fetching data: ' + error.message);
        this.loading = false;
      });
  }

  onChangeDateRange() {
    this.first = 0;
    this.getWithdrawalHealthCheckData(0);
  }

  onClickRow(row: WithdrawalHealthCheckItem) {
    this.dialogService.open(AgentPerformanceDialog, {
      header: 'Agent Performance',
      width: '700px',
      modal: true,
      closable: true,
      contentStyle: { overflow: 'auto' },
      data: {
        agentId: row.agentId,
      },
    });
  }
}
